<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/J3STh/tc-custom/9781426886447.jpg?1725275820842" alt="This image is the cover for the book Arranged Marriage, The Kings of Australia"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Arranged Marriage, The Kings of Australia
      </h1>
      <p class="bookDescription body article font2">
        <p>Alex King is the eldest grandson of a prestigious family. It's his duty to expand the King empireand he must also choose a bride and father a son!<br/><br/>Gina Terlizzi already <i>has</i> a baby sonshe's not looking for a husband! No matter how breathless the chemistry between them, she's simply a guest in Alex's home to attend a weddingor is she the intended bride?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Emma Darcy
      </h2>
      
      <p class="authorDescription body article">Initially a French/English teacher, Emma Darcy changed careers to computer programming before the happy demands of marriage and motherhood. Very much a people person, and always interested in relationships, she finds the world of romance fiction a thrilling one and the challenge of creating her own cast of characters very addictive.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?56bf2314